import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Icon } from "../../Icon";
import { getGroupColors } from "../../../shared/helpers";
import { SlotBox } from "./SlotBox";
import { IconSlot, OverlaySlotIcon } from "../Avatar.styled";
import { useAvatarContext } from "../context/AvatarContext";
const SlotIcon = (props) => {
  const {
    position,
    ...prop
  } = props;
  const { icon, color, ...rest } = prop;
  const { size, parentBg, theme } = useAvatarContext();
  const palette = getGroupColors(theme, parentBg);
  const slotTokens = theme?.avatarV2?.slot;
  const iconSize = size && slotTokens?.variant?.iconImage?.icon[size];
  const slotBorderSize = size && slotTokens?.border[size];
  const slotIconBox = size && slotTokens?.variant?.iconImage?.background[size];
  const transparent = palette?.transparent;
  const slotColorBorder = palette?.main;
  const overlaySlotIconStyle = useMemo(() => {
    return {
      background: transparent
    };
  }, [transparent]);
  if (!icon)
    return null;
  return /* @__PURE__ */ jsx(SlotBox, { position, ...rest, children: /* @__PURE__ */ jsxs(IconSlot, { boxSize: slotIconBox, bg: parentBg, border: slotBorderSize, boxBg: slotColorBorder, children: [
    /* @__PURE__ */ jsx(OverlaySlotIcon, { style: overlaySlotIconStyle }),
    /* @__PURE__ */ jsx(Icon, { icon, color, size: iconSize })
  ] }) });
};
export {
  SlotIcon
};
